// Module
var code = `<table ng-table="\$ctrl.tableConfig" class="table">
  <thead>
  <tr>
    <th ng-repeat="column in \$ctrl.viewColumns">{{column}}</th>
    <th>For payment</th>
    <th>Payment amount</th>
    <th>
      <span ng-if="\$ctrl.collectionsReceiptType === 'TEMPORARY'">TI#</span>
      <span ng-if="\$ctrl.collectionsReceiptType === 'OFFICIAL'">IN#</span>
    </th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$data" ng-if="\$data">
    <td>{{ \$ctrl.getRowNo(\$index, \$ctrl.tableConfig) }}</td>
    <td>{{ item.productNumber }}</td>
    <td>{{ item.customerName }}</td>
    <td>{{ item.customerAddress }}</td>
    <td>{{ item.productName }}</td>
    <td>{{ item.principalAmount | nxCurrency }}</td>
    <td>{{ item.principalBalance | nxCurrency }}</td>
    <td>{{ item.earliestDueDate | prettyDate }}</td>
    <td>{{ item.latestDueDate | prettyDate }}</td>
    <td>{{ item.cbuChargeBalance | nxCurrency }}</td>
    <td>{{ item.dueAmount | nxCurrency }}</td>
    <td>{{ item.overdueAmount | nxCurrency }}</td>
    <td>{{ item.outstandingAmount | nxCurrency }}</td>
    <td>{{ item.status | prettyEnum }}</td>
    <td>
      <input
        type="checkbox"
        ng-model="\$ctrl.getPayment({productId: item.productId}).selected"
        ng-click="\$ctrl.toggleForPayment({collection: item})"/>
    </td>
    <td class="td--small-min-width">
      <cash
        ng-disabled="!\$ctrl.getPayment({productId: item.productId})"
        ng-required="!!\$ctrl.getPayment({productId: item.productId})"
        ng-model="\$ctrl.getPayment({productId: item.productId}).amount"></cash>
    </td>
    <td class="td--small-min-width">
        <span ng-if="\$ctrl.collectionsReceiptType === 'TEMPORARY'">
          <input
            class="dashboard-collections__collections-tr-input"
            type="text"
            ng-model="\$ctrl.getPayment({productId: item.productId}).temporaryReceipt"
            ng-disabled="!\$ctrl.getPayment({productId: item.productId})"
            ng-required="!!\$ctrl.getPayment({productId: item.productId}) && \$ctrl.collectionModuleReceiptRequired"/>
        </span>
      <span ng-if="\$ctrl.collectionsReceiptType === 'OFFICIAL'">
          <input
            class="dashboard-collections__collections-tr-input"
            type="text"
            ng-model="\$ctrl.getPayment({productId: item.productId}).officialReceipt"
            ng-disabled="!\$ctrl.getPayment({productId: item.productId}) || \$ctrl.automatedOfficialReceiptEnabled"
            ng-required="!!\$ctrl.getPayment({productId: item.productId}) && \$ctrl.collectionModuleReceiptRequired"/>
        </span>
    </td>
  </tr>
  <tr>
    <td colspan="{{\$ctrl.viewColumns.length}}"></td>
    <td>Total Payment Amount:</td>
    <td>
      <cash value="\$ctrl.getPaymentsTotalAmount({})" ng-disabled="true"></cash>
    </td>
    <td></td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/collections/payment/individual/collections-payment-individual.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;